import React from 'react'
import styles from './Home.module.css'
import { Link } from 'react-router-dom'

import {
    Wind,
    Droplets,
    Users,
    CalendarDays,
    BookOpen,
    Tag,
    CheckCircle2,
    Bell,
    Calendar,
    Shield,
    Smartphone,
    ArrowRight,
    Heart
} from 'lucide-react'

export default function Home() {
    return (
        <>
            {/* ================= HERO ================= */}
            <section className={styles.hero}>
                <div className="container">
                    <div className={styles.badge}>Din personlige astma & allergi assistent</div>
                    <h1 className={styles.title}>
                        Tag kontrol over din <span className={styles.accent}>astma og allergi</span>
                    </h1>
                    <p className={styles.lead}>
                        Alt du behøver for at håndtere din astma og allergi på ét sted.
                    </p>
                    <div className={styles.ctaRow}>
                        <Link className={styles.primaryCta} to="/signup">Start gratis prøveperiode</Link>
                        <Link className={styles.secondaryCta} to="/funktioner">Se funktioner</Link>
                    </div>
                </div>
            </section>

            {/* ================= FEATURE CARDS ================= */}
            <section className={styles.features}>
                <div className="container">
                    <h2 className={styles.sectionTitle}>Kraftfulde funktioner til din hverdag</h2>
                    <p className={styles.sectionLead}>
                        Vi har samlet alle de værktøjer, du behøver for at leve bedre med astma og allergi
                    </p>

                    <div className={styles.cards}>
                        <article className={styles.card}>
                            <div className={styles.cardText}>
                                <h3>Pollentracker</h3>
                                <p>Se aktuelle pollental og få alarmer ved høje værdier.</p>
                            </div>
                            <div className={styles.cardIcon}><Wind size={22} /></div>
                        </article>

                        <article className={styles.card}>
                            <div className={styles.cardText}>
                                <h3>Luftfugtighed</h3>
                                <p>Real-time fugtighedsdata og notifikationer ved ekstreme værdier.</p>
                            </div>
                            <div className={styles.cardIcon}><Droplets size={22} /></div>
                        </article>

                        <article className={styles.card}>
                            <div className={styles.cardText}>
                                <h3>Community</h3>
                                <p>Stil spørgsmål, del erfaringer og søg viden i emnegrupper.</p>
                            </div>
                            <div className={styles.cardIcon}><Users size={22} /></div>
                        </article>

                        <article className={styles.card}>
                            <div className={styles.cardText}>
                                <h3>Kalender & Påmindelser</h3>
                                <p>Planlæg medicin, rengøring, vaccinationer og få påmindelser.</p>
                            </div>
                            <div className={styles.cardIcon}><CalendarDays size={22} /></div>
                        </article>

                        <article className={styles.card}>
                            <div className={styles.cardText}>
                                <h3>Videncenter</h3>
                                <p>Adgang til artikler og blogs om astma og allergi.</p>
                            </div>
                            <div className={styles.cardIcon}><BookOpen size={22} /></div>
                        </article>

                        <article className={styles.card}>
                            <div className={styles.cardText}>
                                <h3>Rabatter</h3>
                                <p>Eksklusive rabatter til Astma Allergi Shoppen.</p>
                            </div>
                            <div className={styles.cardIcon}><Tag size={22} /></div>
                        </article>
                    </div>
                </div>
            </section>

            {/* ================= POLLEN SECTION ================= */}
            <section className={styles.pollenSection}>
                <div className="container">
                    <div className={styles.twoColumn}>
                        <div className={styles.column}>
                            ...
                        </div>

                        <div className={`${styles.column} ${styles.imageColumn}`}>
                            <img
                                className={styles.roundedImage}
                                src="/bee.jpg"
                                alt="Pollen tracking"
                            />

                            <div className={styles.pollenCard}>
                                <Wind size={28} />
                                <div>
                                    <div className={styles.pollenLabel}>Pollental i dag</div>
                                    <div className={styles.pollenValue}>Middel</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


            {/* ================= CALENDAR SECTION ================= */}
            <section className="calendar-section">
                <div className="container">
                    <div className="two-column">
                        <div className="column">
                            <img
                                className={styles.roundedImage}
                                alt="Medication"
                                src="/inhaler.jpg"
                            />
                        </div>

                        <div className="column">
                            <h2 className="section-title-left">Glem aldrig din medicin igen</h2>
                            <p className="text-large">
                                Smart kalenderstyring med automatiske påmindelser.
                            </p>

                            <div className="reminder-cards">
                                <div className="reminder-card"><Bell size={20} /> Medicin-påmindelser</div>
                                <div className="reminder-card"><Calendar size={20} /> Vaccination tracker</div>
                                <div className="reminder-card"><Shield size={20} /> Automatiske påmindelser</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= COMMUNITY SECTION ================= */}
            <section className={styles['community-section']}>
                <div className="container">
                    <h2 className="section-title">Bliv del af fællesskabet</h2>

                    <div className={styles['community-content']}>
                        <img
                            className={styles.roundedImage}
                            alt="Community"
                            src="https://images.unsplash.com/photo-1761250027507-c0be614c0254"
                        />
                    </div>
                    <div className={styles['stats-grid']}>
                        <div className={styles['stat-card']}>
                            <Users size={48} />
                            <h3>5000+</h3>
                            <p>Aktive medlemmer</p>
                        </div>
                        <div className={styles['stat-card']}>
                            <BookOpen size={48} />
                            <h3>200+</h3>
                            <p>Artikler</p>
                        </div>
                        <div className={styles['stat-card']}>
                            <Smartphone size={48} />
                            <h3>24/7</h3>
                            <p>Tilgængelig</p>
                        </div>
                    </div>

                </div>
            </section>

            {/* ================= CTA ================= */}
            <section id="premium" className="cta-section">
                <div className="container">
                    <h2>Klar til at tage kontrol?</h2>
                    <p>Start din gratis prøveperiode i dag.</p>

                    <div className="cta-buttons">
                        <Link to="/signup" className="btn-primary">
                            Start gratis prøveperiode <ArrowRight size={18} />
                        </Link>
                        <Link to="/funktioner" className="btn-outline">Se funktioner</Link>
                    </div>
                </div>
            </section>

        </>
    )
}
